export const TABLET_BREAKPOINT = 1024;
export const MOBILE_BREAKPOINT = 600;
